module.exports = __webpack_public_path__ + "static/media/osu.cea84cc3.svg";